import React from 'react'
import style from "css/mypage.module.css";

function BookCard({ data, openDetailPop }) {
    console.log("book card data ", data);

    function formatTimeRange(startTime, endTime) {
        function formatTime(isoString) {
            const date = new Date(isoString);
            let hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
            return `${hours}:${minutes}${period}`;
        }

        return `${formatTime(startTime)} - ${formatTime(endTime)}`;
    }

    function getLocation() {
        const dept = data?.LOCATION_DEPARTMENT_TITLE ? `${data.LOCATION_DEPARTMENT_TITLE} > ` : '';
        const resource = data.RESOURCE_TITLE;

        return `${dept}${resource}`
    }
    return (
        <div className={style.bookbox + " cursor"} onClick={() => openDetailPop(data)}>
            <div className={style.bookbox_header}>
                <div className={style.bookbox_title}>{data.RESOURCE_TITLE}</div>
                <div className={style.bookbox_time}>
                    {formatTimeRange(data.START_DATETIME, data.END_DATETIME)}
                </div>
            </div>
            <div className={style.bookbox_footer}>{getLocation()}</div>
        </div>
    )
}

export default BookCard
